module.exports = ".patavium-brand {\r\n  width: 120px;\r\n  height: auto;\r\n}\r\n\r\n.patavium-user {\r\n  position: absolute;\r\n  font-size: 24px;\r\n  left: 240px;\r\n  top: 8px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.css
// module id = ./src/app/components/header/header.component.css
// module chunks = main